import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    undoLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for undo button in toast notification */
            undoLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useDeleteWithAccessCheck.undoLabel?c=n4og3f213zda", defaultMessage: "Undo" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
